import ContactForm from "../components/Contact/Form";
import Details from "../components/Details";
import Footer from "../components/Footer";
import NavBar from "../components/Nav/NavBar";
import Banner from "../components/ui/Banner";

export default function Contact() {
  return ( 
    <div id='root' className="p-4">
        <NavBar />
        <Banner image={""} caption={"Contact"} />
        <Details />
        <ContactForm />
        <Footer />
    </div>
  );
}